<template>
  <div class="user-center">
    <h1>用户中心</h1>
    <div class="user-info">
      <div class="info-item">
        <label>用户名：</label>
        <span>{{ user.name }}</span>
      </div>
      <div class="info-item">
        <label>手机号：</label>
        <span v-if="!editMode">{{ user.phone }}</span>
        <input
          v-else
          v-model="newPhone"
          type="text"
          placeholder="请输入新手机号"
        />
      </div>
      <!-- <div class="info-item">
        <label>邮箱：</label>
        <span v-if="!editMode">{{ user.email }}</span>
        <input
          v-else
          v-model="newEmail"
          type="text"
          placeholder="请输入新邮箱"
        />
      </div> -->
    </div>

    <!-- 验证码输入框（修改信息） -->
    <div v-if="editMode" class="captcha-section">
      <label>验证码：</label>
      <div class="code-input">
        <input v-model="captcha" type="text" placeholder="请输入验证码" />
        <img
          :src="captchaUrl"
          alt="验证码"
          class="captcha-image"
          @click="refreshCaptcha"
        />
      </div>
      <div class="captcha-tip">验证码不区分大小写，点击图片可刷新</div>
    </div>

    <div class="action-buttons">
      <button v-if="!editMode" @click="enterEditMode" class="edit-button">
        修改信息
      </button>
      <button
        v-if="!editMode"
        @click="showPasswordDialog"
        class="password-button"
      >
        修改密码
      </button>
      <!-- <button
        v-if="!editMode && (user.poor === 0 || user.poor === 3)"
        class="rending-button"
        @click="showPoorFileDialog"
      >
        贫困生认定
      </button> -->
      <!-- <div v-if="user.poor === 1" class="poor-status">
        <el-tag type="success">已认定为贫困生</el-tag>
        <div class="poor-tip">下单可享受九折优惠</div>
      </div>
      <div v-if="user.poor === 2" class="poor-status">
        <el-tag type="danger">已成功申请，等待审核中</el-tag>
      </div>
      <div v-if="user.poor === 3" class="poor-status">
        <el-tag type="danger">申请被撤回请重新上传</el-tag>
      </div> -->
      <div v-if="editMode" class="edit-actions">
        <button @click="cancelEdit" class="cancel-button">取消</button>
        <button @click="showConfirmDialog" class="save-button">确认修改</button>
      </div>
    </div>

    <!-- 确认修改弹窗 -->
    <el-dialog
      v-model="confirmDialogVisible"
      title="确认修改"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="confirm-content">
        <p>确定要修改以下信息吗？</p>
        <div v-if="newPhone !== user.phone" class="info-change">
          <span>手机号：</span>
          <span>{{ user.phone }} → {{ newPhone }}</span>
        </div>
        <!-- <div v-if="newEmail !== user.email" class="info-change">
          <span>邮箱：</span>
          <span>{{ user.email }} → {{ newEmail }}</span>
        </div> -->
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="confirmDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmSubmitChanges"
            >确认修改</el-button
          >
        </span>
      </template>
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <el-dialog
      v-model="passwordDialogVisible"
      title="修改密码"
      width="400px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <div class="password-form">
        <div class="form-group">
          <label>新密码：</label>
          <el-input
            v-model="newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
          />
        </div>
        <div class="form-group">
          <label>确认密码：</label>
          <el-input
            v-model="confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
          />
        </div>
        <div class="captcha-section">
          <label>验证码：</label>
          <div class="code-input">
            <el-input v-model="captcha" placeholder="请输入验证码" />
            <img
              :src="captchaUrl"
              alt="验证码"
              class="captcha-image"
              @click="refreshCaptcha"
            />
          </div>
          <div class="captcha-tip">验证码不区分大小写，点击图片可刷新</div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleDialogClose">取消</el-button>
          <el-button type="primary" @click="submitPasswordChange"
            >确认修改</el-button
          >
        </span>
      </template>
    </el-dialog>

    <!-- 贫困生认定文件上传弹窗 -->
    <el-dialog
      v-model="poorFileDialogVisible"
      title="贫困生认定材料上传"
      width="400px"
      :close-on-click-modal="false"
      @close="handlePoorFileDialogClose"
    >
      <div class="poor-file-form">
        <div class="upload-tip">请上传PDF格式的贫困生认定材料</div>
        <el-upload
          class="poor-file-uploader"
          action="https://www.xiaoliangtongxue.cn/api/upload-poor-file"
          :data="{ user_id: user.id }"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
          accept=".pdf"
          :auto-upload="true"
          :limit="1"
        >
          <template #trigger>
            <el-button type="primary">选择文件</el-button>
          </template>
          <template #tip>
            <div class="el-upload__tip">只能上传 PDF 文件</div>
          </template>
        </el-upload>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handlePoorFileDialogClose">关闭</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 优惠券列表 -->
    <div class="coupon-section">
      <h2>我的优惠券</h2>

      <!-- 新用户5元优惠券 -->
      <div v-if="showFreeCoupon" class="coupon-item free-coupon">
        <div class="coupon-value">
          <span class="amount">¥5</span>
          <span class="type">新用户专享</span>
        </div>
        <div class="coupon-info">
          <div class="coupon-code">新用户专享优惠券</div>
          <div class="coupon-time">有效期至：6月20日</div>
          <div class="coupon-condition">无门槛使用</div>
        </div>
        <div class="coupon-status">
          <el-tag type="success" size="small">未使用</el-tag>
        </div>
      </div>

      <div
        v-if="showInnerFreeCoupon"
        class="coupon-item free-coupon"
        style="margin-top: 20px"
      >
        <div class="coupon-value">
          <span class="amount">¥5</span>
          <span class="type">爱心屋自取专享</span>
        </div>
        <div class="coupon-info">
          <div class="coupon-code">
            宝山校区爱心屋专属优惠券(仅限上大师生使用）
          </div>
          <div class="coupon-time">有效期至：6月20日</div>
          <div class="coupon-condition">无门槛使用</div>
        </div>
        <div class="coupon-status">
          <el-tag type="success" size="small">未使用</el-tag>
        </div>
      </div>

      <!-- <div class="coupon-list" v-if="coupons.length > 0">
        <div
          v-for="coupon in coupons"
          :key="coupon.id"
          class="coupon-item"
          :class="{
            'coupon-used': coupon.is_used,
            'coupon-expired': isExpired(coupon),
          }"
        >
          <div class="coupon-value">
            <span class="amount" v-if="coupon.type === 'fixed'"
              >¥{{ coupon.value }}</span
            >
            <span class="amount" v-else
              >{{ (coupon.value / 10).toFixed(1) }}折</span
            >
            <span class="type">{{
              coupon.type === "fixed" ? "优惠券" : "优惠券"
            }}</span>
          </div>
          <div class="coupon-info">
            <div class="coupon-code">优惠码：{{ coupon.code }}</div>
            <div class="coupon-time">
              有效期：{{ formatDate(coupon.start_time) }} 至
              {{ formatDate(coupon.end_time) }}
            </div>
            <div class="coupon-condition" v-if="coupon.min_amount > 0">
              满{{ coupon.min_amount }}元可用
            </div>
          </div>
          <div class="coupon-status">
            {{ getCouponStatus(coupon) }}
          </div>
        </div>
      </div> -->
      <div class="no-coupon" v-else-if="!showFreeCoupon">暂无优惠券</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ElMessage } from "element-plus";

export default {
  name: "UserCenter",
  data() {
    return {
      user: {
        name: localStorage.getItem("userName") || "",
        phone: localStorage.getItem("userPhone") || "",
        email: localStorage.getItem("userEmail") || "",
        id: localStorage.getItem("userId") || "",
        poor: "",
      },
      newPhone: "",
      newEmail: "",
      newPassword: "",
      confirmPassword: "",
      editMode: false,
      passwordDialogVisible: false,
      confirmDialogVisible: false,
      captcha: "",
      captchaUrl: "https://www.xiaoliangtongxue.cn/api/captcha",
      captchaToken: "",
      coupons: [], // 优惠券列表
      poorFileDialogVisible: false, // 贫困生认定文件上传弹窗
      hasOrders: false, // 是否有订单
      showFreeCoupon: false, // 是否显示新用户5元优惠券
      showInnerFreeCoupon: false, // 是否显示校内自取5元优惠券
    };
  },
  methods: {
    getpoor() {
      axios
        .get(`https://www.xiaoliangtongxue.cn/api/user/${this.user.id}/poor`, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response.data.data);
          this.user.poor = response.data.data;
          console.log(this.user);
        });
    },
    showPasswordDialog() {
      this.passwordDialogVisible = true;
      this.refreshCaptcha();
    },
    handleDialogClose() {
      this.passwordDialogVisible = false;
      this.newPassword = "";
      this.confirmPassword = "";
      this.captcha = "";
    },

    // 贫困生认定相关方法
    showPoorFileDialog() {
      this.poorFileDialogVisible = true;
      console.log(this.user);
    },

    handlePoorFileDialogClose() {
      this.poorFileDialogVisible = false;
    },

    beforeUpload(file) {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        ElMessage.error("只能上传PDF文件！");
        return false;
      }
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        ElMessage.error("文件大小不能超过 20MB！");
        return false;
      }
      return true;
    },

    handleUploadSuccess(response) {
      if (response.success) {
        ElMessage.success("贫困生认定材料上传成功！");
        this.user.poor = 2;
        this.handlePoorFileDialogClose();
      } else {
        ElMessage.error(response.message || "上传失败");
      }
    },

    handleUploadError() {
      ElMessage.error("上传失败，请重试");
    },

    enterEditMode() {
      this.editMode = true;
      this.newPhone = this.user.phone;
      this.newEmail = this.user.email;
      this.refreshCaptcha();
    },
    cancelEdit() {
      this.editMode = false;
      this.captcha = "";
    },
    showConfirmDialog() {
      if (!this.newPhone && !this.newEmail) {
        alert("请至少输入一项新信息！");
        return;
      }
      if (this.newPhone && !this.validatePhone(this.newPhone)) {
        alert("请输入有效的手机号！");
        return;
      }
      // if (this.newEmail && !this.validateEmail(this.newEmail)) {
      //   alert("请输入有效的邮箱地址！");
      //   return;
      // }
      this.confirmDialogVisible = true;
    },
    confirmSubmitChanges() {
      this.confirmDialogVisible = false;
      this.submitChanges();
    },
    validatePhone(phone) {
      return /^1[3-9]\d{9}$/.test(phone);
    },
    validateEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    refreshCaptcha() {
      // 添加时间戳避免缓存
      const timestamp = new Date().getTime();
      const url = `https://www.xiaoliangtongxue.cn/api/captcha?t=${timestamp}`;

      axios
        .get(url, {
          withCredentials: true,
          responseType: "blob", // 重要！指定响应类型为 blob
        })
        .then((response) => {
          // 从响应头获取 token
          const token = response.headers.get("X-Captcha-Token");
          if (token) {
            this.captchaToken = token;
          }
          // 创建图片 URL
          this.captchaUrl = URL.createObjectURL(response.data);
        })
        .catch((error) => {
          console.error("获取验证码失败:", error);
          // 如果 axios 失败，回退到直接设置 URL
          this.captchaUrl = url;
        });
    },
    async submitChanges() {
      if (this.newPhone && !this.validatePhone(this.newPhone)) {
        alert("请输入有效的手机号！");
        return;
      }

      // if (this.newEmail && !this.validateEmail(this.newEmail)) {
      //   alert("请输入有效的邮箱地址！");
      //   return;
      // }

      if (!this.captcha) {
        alert("请输入验证码！");
        return;
      }

      const payload = {
        user_id: this.user.id,
        captcha: this.captcha,
        captcha_token: this.captchaToken,
      };

      // 只有当值发生变化时才添加到payload
      if (this.newPhone !== this.user.phone) payload.phone = this.newPhone;
      if (this.newEmail !== this.user.email) payload.email = this.newEmail;

      // 如果没有任何修改，直接返回
      if (!payload.phone && !payload.email) {
        alert("请至少修改一项信息！");
        return;
      }

      try {
        const response = await axios.post(
          "https://www.xiaoliangtongxue.cn/api/update-user-info",
          payload,
          {
            withCredentials: true,
          }
        );
        if (response.data.success) {
          // 更新本地存储的用户信息
          if (payload.phone) localStorage.setItem("userPhone", payload.phone);
          if (payload.email) localStorage.setItem("userEmail", payload.email);

          // 更新组件中的用户信息
          this.user = {
            ...this.user,
            phone: payload.phone || this.user.phone,
            email: payload.email || this.user.email,
          };

          alert("用户信息更新成功！");
          this.editMode = false;
          this.captcha = "";
        } else {
          alert(response.data.message);
          this.refreshCaptcha();
        }
      } catch (error) {
        alert(error.response?.data?.message || "更新失败，请重试！");
        console.error(error);
        this.refreshCaptcha();
      }
    },
    async submitPasswordChange() {
      if (!this.newPassword) {
        ElMessage.warning("请输入新密码！");
        return;
      }

      if (this.newPassword.length < 6) {
        ElMessage.warning("密码长度不能少于6位！");
        return;
      }

      if (this.newPassword !== this.confirmPassword) {
        ElMessage.warning("两次输入的密码不一致！");
        return;
      }

      if (!this.captcha) {
        ElMessage.warning("请输入验证码！");
        return;
      }

      try {
        const response = await axios.post(
          "https://www.xiaoliangtongxue.cn/api/reset-password",
          {
            phone: this.user.phone,
            email: this.user.email,
            new_password: this.newPassword,
            captcha: this.captcha,
            captcha_token: this.captchaToken,
          },
          {
            withCredentials: true,
          }
        );
        if (response.data.success) {
          ElMessage.success("密码修改成功！");
          this.handleDialogClose();
        } else {
          ElMessage.error(response.data.message);
          this.refreshCaptcha();
        }
      } catch (error) {
        ElMessage.error("修改失败，请重试！");
        console.error(error);
        this.refreshCaptcha();
      }
    },

    // 新增：获取用户优惠券列表
    async fetchCoupons() {
      try {
        const response = await axios.get(
          `https://www.xiaoliangtongxue.cn/api/coupon`,
          {
            params: {
              user_id: this.user.id, // 移除 is_used 过滤，显示所有优惠券
            },
            withCredentials: true,
          }
        );
        if (Array.isArray(response.data)) {
          this.coupons = response.data.filter(
            (coupon) =>
              coupon.user_id === null || // 通用优惠券
              coupon.user_id === parseInt(this.user.id) // 用户专属优惠券
          );
        } else {
          console.error("获取优惠券返回格式错误");
          this.coupons = [];
        }
      } catch (error) {
        console.error("获取优惠券失败：", error);
        this.coupons = [];
      }
    },

    // 判断优惠券是否过期
    isExpired(coupon) {
      const now = new Date();
      const endTime = new Date(coupon.end_time);
      return now > endTime;
    },

    // 格式化日期
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")}`;
    },

    // 获取优惠券状态文本
    getCouponStatus(coupon) {
      if (coupon.is_used) return "已使用";
      if (this.isExpired(coupon)) return "已过期";
      const now = new Date();
      const startTime = new Date(coupon.start_time);
      if (now < startTime) return "未生效";
      return "可使用";
    },

    // 检查用户是否有订单
    async checkHasOrders() {
      try {
        const response = await axios.get(
          "https://www.xiaoliangtongxue.cn/api/order/has-order",
          {
            params: {
              user_id: this.user.id,
            },
            withCredentials: true,
          }
        );

        if (response.data.success) {
          this.hasOrders = response.data.has_orders;
          //console.log(response.data);
          // 如果没有订单，显示5元新用户优惠券
          if (!response.data.has_orders) {
            this.showFreeCoupon = true;
          }
          if (!response.data.inner_has_orders) {
            this.showInnerFreeCoupon = true;
          }
        }
      } catch (error) {
        console.error("检查订单失败：", error);
      }
    },
  },
  mounted() {
    this.fetchCoupons(); // 页面加载时获取优惠券列表
    this.getpoor();
    this.checkHasOrders(); // 检查是否有订单，决定是否显示新用户优惠券
  },
};
</script>

<style scoped>
.user-center {
  max-width: 800px;
  margin: 40px auto;
  padding: 30px;
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

h1 {
  text-align: center;
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 30px;
  position: relative;
  padding-bottom: 15px;
}

h1::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, #42b983, #3498db);
  border-radius: 3px;
}

.user-info {
  background: #f8fafc;
  padding: 25px;
  border-radius: 12px;
  margin-bottom: 25px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.info-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #eef2f7;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item label {
  width: 100px;
  font-weight: 600;
  color: #606f7b;
  font-size: 15px;
}

.info-item span {
  flex: 1;
  color: #2c3e50;
  font-size: 15px;
}

.info-item input {
  flex: 1;
  padding: 10px 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background-color: white;
  transition: all 0.3s ease;
}

.info-item input:focus {
  border-color: #42b983;
  box-shadow: 0 0 0 3px rgba(66, 185, 131, 0.1);
  outline: none;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin: 30px 0;
}

button {
  padding: 12px 25px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:hover {
  transform: translateY(-2px);
}

.edit-button {
  background: linear-gradient(135deg, #42b983, #3cb371);
  color: white;
  box-shadow: 0 4px 15px rgba(66, 185, 131, 0.2);
}

.edit-button:hover {
  box-shadow: 0 6px 20px rgba(66, 185, 131, 0.3);
}

.password-button {
  background: linear-gradient(135deg, #ff9800, #f57c00);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.2);
}

.rending-button {
  background: linear-gradient(135deg, #00d9ff, #0066f5);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.2);
}

.password-button:hover {
  box-shadow: 0 6px 20px rgba(255, 152, 0, 0.3);
}

.cancel-button {
  background: #f5f6fa;
  color: #606f7b;
  border: 1px solid #e2e8f0;
}

.cancel-button:hover {
  background: #edf2f7;
}

.save-button {
  background: linear-gradient(135deg, #3498db, #2980b9);
  color: white;
  box-shadow: 0 4px 15px rgba(52, 152, 219, 0.2);
}

.save-button:hover {
  box-shadow: 0 6px 20px rgba(52, 152, 219, 0.3);
}

.captcha-section,
.password-section {
  background: #f8fafc;
  padding: 25px;
  border-radius: 12px;
  margin-top: 25px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #606f7b;
  font-size: 15px;
}

.form-group input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background-color: white;
  transition: all 0.3s ease;
}

.form-group input:focus {
  border-color: #42b983;
  box-shadow: 0 0 0 3px rgba(66, 185, 131, 0.1);
  outline: none;
}

.code-input {
  display: flex;
  gap: 15px;
  align-items: center;
}

.code-input input {
  flex: 1;
  padding: 12px 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background-color: white;
  transition: all 0.3s ease;
}

.code-input input:focus {
  border-color: #42b983;
  box-shadow: 0 0 0 3px rgba(66, 185, 131, 0.1);
  outline: none;
}

.captcha-image {
  height: 44px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.captcha-image:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

.captcha-tip {
  margin-top: 8px;
  color: #8795a1;
  font-size: 13px;
  font-style: italic;
}

.coupon-section {
  margin-top: 30px;
  background: #ffffff;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.coupon-section h2 {
  font-size: 20px;
}

/* 新用户优惠券样式 */
.free-coupon {
  background: linear-gradient(135deg, #67c23a, #52a332);
  border: 2px solid #67c23a;
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.25);
}

.free-coupon .coupon-value {
  border-right: 1px dashed rgba(255, 255, 255, 0.5);
}

.free-coupon .coupon-value .amount {
  color: #fff;
}

.free-coupon .coupon-value .type {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 500;
}

.free-coupon .coupon-info {
  padding-left: 20px;
}

.free-coupon .coupon-code {
  font-size: 16px;
  color: #fff;
}

.free-coupon .coupon-time,
.free-coupon .coupon-condition {
  color: rgba(255, 255, 255, 0.95);
  font-size: 13px;
}

.free-coupon .coupon-status {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  font-weight: 500;
}

.coupon-section h2 {
  color: #2c3e50;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f2f5;
}

.coupon-list {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

.coupon-item {
  display: flex;
  background: linear-gradient(135deg, #42b983, #3cb371);
  border-radius: 12px;
  padding: 20px;
  color: white;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.coupon-used {
  background: linear-gradient(135deg, #95a5a6, #7f8c8d);
  opacity: 0.8;
}

.coupon-expired {
  background: linear-gradient(135deg, #95a5a6, #7f8c8d);
  opacity: 0.8;
}

.coupon-value {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 20px;
  border-right: 1px dashed rgba(255, 255, 255, 0.3);
  min-width: 120px;
}

.coupon-value .amount {
  font-size: 28px;
  font-weight: bold;
}

.coupon-value .type {
  font-size: 14px;
  margin-top: 5px;
}

.coupon-info {
  flex: 1;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.coupon-code {
  font-size: 16px;
  margin-bottom: 8px;
}

.coupon-time {
  font-size: 12px;
  opacity: 0.9;
  margin-bottom: 5px;
}

.coupon-condition {
  font-size: 12px;
  opacity: 0.9;
}

.coupon-status {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 12px;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.no-coupon {
  text-align: center;
  padding: 40px;
  color: #8795a1;
  font-size: 16px;
  background: #f8fafc;
  border-radius: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .user-center {
    margin: 20px;
    padding: 20px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .info-item label {
    width: 100%;
  }

  .action-buttons {
    flex-direction: column;
  }

  button {
    width: 100%;
  }

  .password-button {
    margin-left: 0;
    margin-top: 10px;
  }

  .coupon-list {
    grid-template-columns: 1fr;
  }

  .coupon-item {
    flex-direction: column;
  }

  .coupon-value {
    border-right: none;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.3);
    padding-right: 0;
    padding-bottom: 15px;
    margin-bottom: 15px;
    text-align: center;
  }

  .coupon-info {
    padding-left: 0;
    text-align: center;
  }
}

/* 弹窗样式覆盖 */
:deep(.el-dialog) {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

:deep(.el-dialog__header) {
  margin: 0;
  padding: 20px 25px;
  background: linear-gradient(135deg, #42b983, #3cb371);
}

:deep(.el-dialog__title) {
  color: white;
  font-size: 18px;
  font-weight: 600;
}

:deep(.el-dialog__headerbtn) {
  top: 20px;
  right: 20px;
}

:deep(.el-dialog__headerbtn .el-dialog__close) {
  color: white;
}

:deep(.el-dialog__headerbtn:hover .el-dialog__close) {
  color: #e0e0e0;
}

:deep(.el-dialog__body) {
  padding: 30px 25px;
}

:deep(.el-dialog__footer) {
  padding: 15px 25px 25px;
  border-top: 1px solid #f0f2f5;
}

.password-form {
  padding: 0;
}

.password-form .form-group {
  margin-bottom: 20px;
}

.password-form .form-group label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #606f7b;
  font-size: 15px;
}

:deep(.el-input__wrapper) {
  width: 100%;
  box-shadow: 0 0 0 1px #e2e8f0;
  border-radius: 8px;
  padding: 0 15px;
  transition: all 0.3s ease;
}

:deep(.el-input__wrapper:hover) {
  box-shadow: 0 0 0 1px #cbd5e0;
}

:deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px #42b983, 0 0 0 3px rgba(66, 185, 131, 0.1);
}

:deep(.el-input__inner) {
  height: 40px;
  color: #2c3e50;
  font-size: 15px;
}

/* 验证码部分样式 */
.password-form .captcha-section {
  margin-top: 25px;
  padding: 0;
  background: none;
  box-shadow: none;
}

.password-form .code-input {
  display: flex;
  gap: 15px;
  align-items: center;
}

.password-form .captcha-image {
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.password-form .captcha-image:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

.password-form .captcha-tip {
  margin-top: 8px;
  color: #8795a1;
  font-size: 13px;
  font-style: italic;
}

/* 按钮样式 */
:deep(.el-button) {
  height: 40px;
  padding: 0 25px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
}

:deep(.el-button:hover) {
  transform: translateY(-2px);
}

:deep(.el-button--default) {
  border-color: #e2e8f0;
  background: #f5f6fa;
  color: #606f7b;
}

:deep(.el-button--default:hover) {
  background: #edf2f7;
  border-color: #cbd5e0;
}

:deep(.el-button--primary) {
  background: linear-gradient(135deg, #42b983, #3cb371);
  border: none;
  box-shadow: 0 4px 15px rgba(66, 185, 131, 0.2);
}

:deep(.el-button--primary:hover) {
  background: linear-gradient(135deg, #3cb371, #2fa866);
  box-shadow: 0 6px 20px rgba(66, 185, 131, 0.3);
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 0;
}

.captcha-section {
  background: #f8fafc;
  padding: 25px;
  border-radius: 12px;
  margin-bottom: 25px; /* 添加底部间距 */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  animation: fadeIn 0.3s ease;
}

/* 贫困生认定文件上传样式 */
.poor-file-form {
  padding: 20px 0;
}

.upload-tip {
  margin-bottom: 20px;
  color: #606f7b;
  font-size: 14px;
}

.poor-file-uploader :deep(.el-upload) {
  width: 100%;
  text-align: center;
}

.poor-file-uploader :deep(.el-button) {
  width: 100%;
  margin-bottom: 10px;
}

.el-upload__tip {
  color: #8795a1;
  font-size: 12px;
  line-height: 1.4;
}

/* 贫困生状态样式 */
.poor-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
}

.poor-tip {
  color: #67c23a;
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .poor-status {
    width: 100%;
    margin: 15px 0;
  }
}

.confirm-content {
  padding: 20px 0;
}

.confirm-content p {
  margin-bottom: 15px;
  color: #606f7b;
  font-size: 15px;
}

.info-change {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 14px;
}

.info-change span:first-child {
  font-weight: 600;
  color: #2c3e50;
}

.info-change span:last-child {
  color: #67c23a;
  font-family: monospace;
}
</style>